export const PROFILE_TEXT_MAX_LENGTH = 40;

function normalizeWhitespace(value) {
  return String(value ?? "").replace(/\s+/g, " ").trim();
}

export function limitProfileText(value, max = PROFILE_TEXT_MAX_LENGTH) {
  const text = normalizeWhitespace(value);
  if (!Number.isFinite(max) || max <= 0) return "";
  return text.slice(0, max);
}

export function trimAndLimitProfileText(value, max = PROFILE_TEXT_MAX_LENGTH) {
  const text = normalizeWhitespace(value);
  if (!Number.isFinite(max) || max <= 0) return "";
  return text.slice(0, max);
}

export function ellipsizeProfileText(value, max = PROFILE_TEXT_MAX_LENGTH) {
  const text = normalizeWhitespace(value);
  if (!text) return "";
  if (!Number.isFinite(max) || max <= 0) return "";
  return text.length > max ? `${text.slice(0, max)}...` : text;
}
